import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { CheckCircle, WarningCircle } from 'phosphor-react';

function DataImportSuccessfullyModal({
  open,
  setOpen,
  isRefreshData
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isRefreshData: boolean;
}): JSX.Element {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white pt-16 text-left shadow-xl transition-all max-w-[558px]">
                <div>
                  <CheckCircle
                    weight="bold"
                    className="mx-auto mt-1 flex h-14 w-14 items-center justify-center rounded-full text-gray-400"
                  />
                  <div className="mt-7 text-center">
                    <Dialog.Title as="h3" className="text-xl font-bold leading-8 text-gray-900">
                      {isRefreshData ? 'Data refresh successful' : 'Import successful'}
                    </Dialog.Title>

                    <div className="mt-2 text-base text-gray-500 mx-24 tracking-wide">
                      {isRefreshData
                        ? `We successfully re-imported your data. If you are missing any required fields, or 
                        there are any other errors they will be highlighted here so you can fix them.`
                        : `We successfully imported your file. If you are missing any required fields, or there are any other errors they will be highlighted here so you can fix them.`}
                    </div>
                  </div>
                </div>
                <div className="flex justify-center text-sm mt-8 text-gray-600 tracking-wide">
                  <div className="flex items-center mr-6">
                    <div className="mx-auto flex h-6 w-6 items-center justify-center rounded-full bg-pale-pink mr-1">
                      <WarningCircle size={16} weight="fill" className="text-dark-coral" />
                    </div>
                    Formatting issue
                  </div>
                  <div className="flex items-center">
                    <div className="mx-auto flex h-6 w-6 items-center justify-center rounded-full bg-antique-white mr-1">
                      <WarningCircle size={16} weight="fill" className="text-sunray" />
                    </div>
                    Missing required field
                  </div>
                </div>

                <div className="mt-9 mx-24 mb-14 sm:grid outline-none">
                  <button type="button" className="btn-primary" onClick={() => setOpen(false)}>
                    Review and complete data
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default DataImportSuccessfullyModal;
